// Module
var code = "<div id=\"V-390922B5-FFA2-47B9-B3BC-6C3F543AFD69\"> <div data-b-component=\"button\" class=\"primary button\" data-b-event-click=\"{Binding edit}\">Edit</div> </div> ";
// Exports
export default code;